(() => {
  let flag = 1;
  window.onLibReady = onLibReady;

  document.addEventListener('DOMContentLoaded', function () {
    const pathList = ['/pages/promo-code', '/pages/custom-waffle-maker', '/pages/dough-mixes-discount'];

    if (pathList.includes(location.pathname)) {
      init();
    } else {
      window.addEventListener('scroll', init, {passive: true});
      window.addEventListener('mousemove', init, {passive: true});
      window.addEventListener('touchstart', init, {passive: true});
    }
  });

  function init() {
    window.headScriptObserver.disconnect();

    if (flag) {
      flag = 0;

      window.removeEventListener('scroll', init);
      window.removeEventListener('mousemove', init);
      window.removeEventListener('touchstart', init);

      loadSections();
      loadVendors();
      lazyLoadImage();
      lazyLoadBgImage();
      lazyLoadIframe();
      loadAllJs();
    }
  }

  function lazyLoadImage() {
    document.querySelectorAll('[data-src]').forEach(function (elem) {
      elem.src = elem.dataset.src;
    });
  }

  function lazyLoadBgImage() {
    document.querySelectorAll('[data-bgsrc]').forEach(function (elem) {
      elem.style.backgroundImage = `url(${elem.dataset.bgsrc})`;
    });
  }

  function lazyLoadIframe() {
    document.querySelectorAll('iframe').forEach(function (elem) {
      elem.src = elem.dataset.src || elem.src;
    });
  }

  function loadAllJs() {
    setTimeout(function () {
      window.dispatchEvent(new Event('ez_load'));
      document.dispatchEvent(new Event('ez_load'));
    }, 100);

    const lazyScripts = document.getElementsByTagName('script');
    Array.from(lazyScripts).forEach(s => {
      if (s.type === 'lazyload.js') {
        const script = s.cloneNode(true);
        script.type = s.dataset.type ? s.dataset.type : 'text/javascript';

        if (s.src) {
          script.src = s.src;
          document.head.appendChild(script);
        } else if (s.innerHTML) {
          document.body.appendChild(script);
        }

        s.remove();
      }
    });
  }

  function loadVendors() {
    const scriptsToLoad = [
      {
        name: 'geoip2',
        src: '//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js',
      },
      {
        name: 'swiper',
        src: getShopifyLink('swiper.min.js'),
      },
      {
        name: 'vue',
        src: getShopifyLink('vue.min.js'),
      },
      {
        name: 'fancybox',
        src: getShopifyLink('fancybox.js'),
      },
      {
        name: 'body-scroll-lock',
        src: getShopifyLink('body-scroll-lock.js'),
      },
      {
        name: 'js-image-zoom',
        src: getShopifyLink('js-image-zoom.js'),
      },
    ];

    const tag = document.getElementsByTagName('script')[0];

    scriptsToLoad.forEach(s => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = s === null || s === void 0 ? void 0 : s.src;
      script.addEventListener('load', e => {
        window.Shopify.vendors = window.Shopify.vendors || [];
        window.Shopify.vendors.push(s.name);
        document.dispatchEvent(new CustomEvent(`${s.name}.loaded`));
      });

      return tag.parentNode.insertBefore(script, tag);
    });
  }

  function onLibReady(libs, callback) {
    const interval = setInterval(() => {
      if (libs.every(lib => window.Shopify.vendors?.includes(lib))) {
        clearInterval(interval);
        typeof callback === 'function' && callback();
      }
    }, 100);
  }

  function loadSections() {
    const sectionList = document.querySelectorAll('[data-section-postload]');
    sectionList.forEach(section => {
      const breakpoint = section.dataset.sectionBreakpoint;

      if (window.innerWidth >= breakpoint || !breakpoint) {
        fetchSection(section);
      }
    });
  }

  function fetchSection(section) {
    let url = `/?view=sections&section_id=${section.dataset.sectionId}`;

    if (['collection', 'product'].includes(Shopify.template)) {
      url = `${location.pathname}?view=sections&section_id=${section.dataset.sectionId}`;
    }

    fetch(url)
      .then(response => response.text())
      .then(text => {
        section.innerHTML = text;
      });
  }
})();
